<template>
    <div class="svg-circle-wrapper">
        <svg viewBox="0 0 200 200" preserveAspectRatio="xMinYMin meet">
            <circle :cx="radius" :cy="radius" :r="normalizedRadius" :stroke-width="stroke" :stroke="theme.track"></circle>
            <circle :cx="radius" :cy="radius" :r="normalizedRadius" :stroke-width="stroke" :stroke="theme.stroke" :stroke-dasharray="circumference + ' ' + circumference" :style="{ strokeDashoffset: strokeDashoffset }"></circle>
        </svg>
        <p :style="'color: ' + theme.text">{{ ( max !== 100 && value > 0 ) ? ( value / max * 100 ).toFixed( 1 ) : value }}{{ unit }}</p>
    </div>
</template>

<style lang="scss" scoped>
    // see /static/scss/components/_progressRing.scss
</style>

<script>
    import { gsap } from '@/vendor';

    export default {
        props: {
            radius: {
                type: Number,
                default: 115
            },
            min: {
                type: Number,
                default: 0
            },
            max: {
                type: Number,
                default: 100
            },
            value: {
                type: Number,
                default: 0
            },
            unit: {
                type: String,
                default: '%'
            },
            stroke: {
                type: Number,
                default: 10
            },
            smooth: {
                type: Boolean,
                default: false
            },
            theme: {
                type: Object,
                default: () =>
                {
                    return {
                        text: '#000000',
                        stroke: '#A5147E',
                        track: '#ffffff'
                    };
                }
            }
        },

        data()
        {
            const normalizedRadius = this.radius - this.stroke * 2;
            const circumference = normalizedRadius * 2 * Math.PI;

            return {
                normalizedRadius,
                circumference,

                adjustableProgress: this.progress
            };
        },

        computed: {
            progress()
            {
                let progress = 100 / ( this.max - this.min ) * ( this.value - this.min );
                return Math.round( progress );
            },
            strokeDashoffset()
            {
                return this.circumference - this.adjustableProgress / 100 * this.circumference;
            }
        },

        watch: {
            'progress'( val )
            {
                if( !this.smooth )
                {
                    this.adjustableProgress = val;
                    return;
                }
                if( this.anim )
                {
                    this.anim.kill();
                }
                this.anim = gsap.to( this, { adjustableProgress: val, duration: 1 });
            }
        },

        mounted()
        {
            this.anim = gsap.to( this, { adjustableProgress: this.progress, duration: 1 });
        },

        methods: {
        }

    };
</script>
